export default "__VITE_ASSET__Cf0G_eVF__"